var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{staticClass:"pb-4",attrs:{"xs6":"","lg4":""}},[_c('v-avatar',{class:_vm.avatarClass,attrs:{"size":"38px"},on:{"click":_vm.toggleFilter}},[_c('v-icon',{attrs:{"color":_vm.color,"dark":""}},[_vm._v(_vm._s(_vm.icon))])],1),_c('h5',{staticClass:"body-1 primary--text d-inline pl-3"},[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }